import {Injectable, computed, signal, inject, effect, WritableSignal} from '@angular/core';
//import {AccessMicrophoneService } from '@llm/service/microphone.service';
import {llmStoreService} from '@llm/service/llm_store.service';
import {Perzonalized_Console} from '@llm/utils/perzonalized_console'


@Injectable({
  providedIn: 'root'
})
export class UiStateService {
  //microphoneService = inject(AccessMicrophoneService);
  store = inject(llmStoreService);
  private _console = inject(Perzonalized_Console);
  // Signals de estado primarios
  //Grabando audio de usuario
  /**
   * Grabando audio de usuario
   * */
  private _isRecording = signal<boolean>(false);
  private _isListening = signal<boolean>(false);//Reconociendo entradas de usuario
  private _isSpeak = signal<boolean>(false);//Nitro hablando
  private _isProcessingAudio = signal<boolean>(false);//Procesando audio
  private _isProcessingText = signal<boolean>(false);//Procesando texto
  private _isUserTyping = signal<boolean>(false);//Usuario escribiendo
  private _isShowChat = signal<boolean>(false);//Control de visualizacion del chat
  private _isNovoMessage = signal<boolean>(true);//Control de visualizacion del chat
  public _isRenderedTranscription = signal<string>('')
  public readonly isPageVisible = signal<boolean>(true);//Control de visibilidad de la pagina
  //private _isPlaying = signal<boolean>(false);

  // Signals computados para estados derivados
  public isDisabledPermisionUserTextEntry = computed(()=>{
    this._console.log(`isDisabledPermisionUserTextEntry: ${this.store.isSpeaking()} ***${this.store.isProcessingAudio()}***${this.store.isProcessingText()}`);
    this.store.isSpeaking() ||
    this.store.isProcessingAudio() ||
    this.store.isProcessingText()
  })

  /**
   * Signal publico encargado de controlar el acceso de la aplicación al microfono
   * */
  public readonly _isAppAutorizedRecognizing = computed(() =>
    this.store.isInteractionVoiceIntentStatus() &&
    this.isPageVisible()
  )

  /**
   * Signal computado encargado de habilitar o
   * desabilitar el boton de settings del bot
   * */
  public readonly isHabilitedButtonSettings = computed(() =>
    !this.store.isRecording()
    && !this.store.isSpeaking()
    && !this.store.isProcessingAudio()
    && !this.store.isUserTypingText()
    && !this.store.isProcessingText()
  )



  public showMicrophoneIcon = computed(() =>
    this.store.settingsToolsAi().voiceInteractionEnabled &&
    this.store.isMicrophoneAccessGranted() &&
    !this.store.isUserTypingText()
  );
  public showSendButton = computed(() =>
    this.store.isUserTypingText() ||
    !this.store.isInteractionVoiceIntentStatus()
  );
  public showMicrophoneOffIcon = computed(() =>
    !this.store.isMicrophoneAccessGranted() &&
    !this.store.isUserTypingText()
  );


  //Signals encargado de la visibilidad del sitio
  public setPageVisibility(isVisible: boolean): void {
    if (this.isPageVisible() !== isVisible) {
      this.isPageVisible.set(isVisible);
      //console.log(`[UiStateService] Visibilidade da página alterada para: ${isVisible}`);
    }
  }


  public soundWaveVisible = computed(() => this._isRecording());

  public canStartRecording = computed(() =>
    this.store.isMicrophoneAccessGranted() &&
    !this._isRecording() &&
    !this._isProcessingAudio() &&
    !this._isProcessingText()
  );


  /**
   * @description Getters de Todas as Signals Declaradas.
   *
   * Estes getters públicos permitem que outras partes da aplicação
   * (componentes, outros serviços, `computed`s) obtenham uma **referência**
   * aos `WritableSignal`s privados. Ao obter esta referência e "chamar" o signal
   * (ex: `meuServico.isRecording()`), o Angular estabelece uma conexão reativa,
   * garantindo que a UI ou outros cálculos se atualizem automaticamente
   * quando o valor do signal mudar.
   *
   * @remarks
   * Esses getters são cruciais para a reatividade, pois expõem o signal sem
   * permitir a substituição direta da sua instância original por consumidores externos.
   */


  // Efectos para manejar transiciones de estado
  constructor() {}

  // Métodos para modificar estados
  startRecording() {
    if (this.canStartRecording()) {
      this._isRecording.set(true);
    }
  }
  changeStateNovoMessage(state: boolean) {
    this._isNovoMessage.set(state);
  }

  stopRecording() {
    this._isRecording.set(false);
    this._isProcessingAudio.set(true);
  }

  startAudioPlayback() {
    this._isSpeak.set(true);
  }

  stopAudioPlayback() {
    this._isSpeak.set(false);
  }

  audioProcessingComplete() {
    this._isProcessingAudio.set(false);
    this._isProcessingText.set(true);
  }

  textProcessingComplete() {
    this._isProcessingText.set(false);
  }

  setUserTyping(isTyping: boolean) {
    this._isUserTyping.set(isTyping);
  }

  openChat() {
    this._isShowChat.set(true);
  }

  closeChat() {
    this._isShowChat.set(false);
  }

  resetStates() {
    this._isRecording.set(false);
    this._isListening.set(false);
    this._isSpeak.set(false);
    this._isProcessingAudio.set(false);
    this._isProcessingText.set(false);
    this._isUserTyping.set(false);
  }

  set isListening(isListening: boolean) {
    this._isListening.set(isListening);
  }

  // Exposición de signals (solo lectura)
  //get isListening() { return this._isListening.asReadonly(); }
  get isSpeak() { return this._isSpeak.asReadonly(); }
  get isProcessingAudio() { return this._isProcessingAudio.asReadonly(); }
  get isProcessingText() { return this._isProcessingText.asReadonly(); }
  get isUserTyping() { return this._isUserTyping.asReadonly(); }

  get isAccessMicrophone() {
    return this.store.isMicrophoneAccessGranted();
  }
  get isShowChat() { return this._isShowChat.asReadonly(); }
  get isNovoMessage() { return this._isNovoMessage.asReadonly(); }
}
